<h1>Track My Workout</h1>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<section id="track-my-workout">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8">
                <div class="card mt-4" id="track-workout-card">
                    <div class="card-header">In here, you can track your workouts! Just enter the corresponding information:</div>
                    <div class="card-body">
                        <form id="add-workout" class="mb-2">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 col-md-10">
                                        <div class="form-group">
                                            <label for="workout-name-input">Workout Name:</label>
                                            <input class="workout-name-input" type="text" id="workout-name-input"
                                                name="workout-name-input" [(ngModel)]="workoutName"
                                                placeholder="Workout Name">
                                            <br><br>
                                            <div>
                                                <label for="sets-input">Sets:
                                                    <input class="sets-input" id="sets-input" type="number"
                                                        id="sets-input" name="sets-input" min="0" max="1000"
                                                        [(ngModel)]="sets" placeholder="Sets">
                                                </label>
                                                <label for="reps-input">Reps:
                                                    <input class="reps-input" id="reps-input" type="number"
                                                        id="reps-input" name="reps-input" min="0" max="1000"
                                                        [(ngModel)]="reps" placeholder="Reps">
                                                </label>
                                                <label for="weight-input">Weight(lbs.):
                                                    <input class="weight-input" id="weight-input" type="number"
                                                        id="weight-input" name="weight-input" min="0" max="100000"
                                                        [(ngModel)]="weight" placeholder="Weight">
                                                </label>
                                            </div>
                                            <button type="button" class="add-exercise-btn" id="add-exercise-btn"
                                                (click)="AddExercise()"
                                                [disabled]="!workoutName || !sets || !reps || !weight"><i
                                                    class="fa fa-plus"></i> Add
                                                Exercise
                                            </button>
                                            <button type="button" class="clear-exercise-btn" id="clear-exercise-btn"
                                                (click)="ClearExercise()" [disabled]="!rows.length"><i
                                                    class="fa fa-times"></i> Clear
                                                Exercises
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="table-div">
        <table class="table table-striped" id="add-workout-table">
            <thead>
                <tr>
                    <th colspan="5">Your Workout</th>
                </tr>
                <tr>
                    <th>Workout Name</th>
                    <th>Sets</th>
                    <th>Reps</th>
                    <th>Weight</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr class="workout-list" *ngFor="let row of rows">
                    <td>{{row.workoutName}}</td>
                    <td>{{row.sets}}</td>
                    <td>{{row.reps}}</td>
                    <td>{{row.weight}}</td>
                    <td><button type="button" class="remove-exercise-btn" id="remove-exercise-btn"
                            (click)="RemoveExercise(row)" [disabled]="!rows.length"><i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>   
            </tbody>
        </table>
    </div>
</section>